import { interventionTypes, absenceTypes } from '../utils';

const InterventionTypeSection = ({ formData, setFormData }) => {
  const isAbsence = formData.intervention_type === 'absence';
  const isOther = formData.intervention_type === 'other';

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Tipo Intervento <span className="text-red-500">*</span>
      </label>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
        {interventionTypes.map((type) => (
          <label
            key={type.value}
            className={`flex items-center gap-2 p-3 border rounded-lg cursor-pointer transition ${
              formData.intervention_type === type.value
                ? 'border-2 shadow-sm'
                : 'border-gray-300 hover:bg-gray-50'
            }`}
            style={{
              borderColor: formData.intervention_type === type.value ? type.color : undefined,
              backgroundColor: formData.intervention_type === type.value ? `${type.color}10` : undefined
            }}
            data-testid={`intervention-type-${type.value}`}
          >
            <input
              type="radio"
              name="intervention_type"
              value={type.value}
              checked={formData.intervention_type === type.value}
              onChange={(e) => {
                const newType = e.target.value;
                setFormData({
                  ...formData,
                  intervention_type: newType,
                  // Reset absence-specific fields when switching away
                  absence_type: newType === 'absence' ? (formData.absence_type || '') : null,
                  absence_full_day: newType === 'absence' ? (formData.absence_full_day !== false) : null,
                  // Reset "altro" motivo when switching away
                  other_reason: newType === 'other' ? (formData.other_reason || '') : null,
                });
              }}
              className="sr-only"
            />
            <span className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: type.color }} />
            <span className="text-sm font-medium text-gray-700">{type.label}</span>
          </label>
        ))}
      </div>

      {/* Absence-specific subfields */}
      {isAbsence && (
        <div className="mt-3 p-4 bg-slate-50 border border-slate-200 rounded-lg space-y-3" data-testid="absence-details">
          <div>
            <label className="block text-xs font-semibold text-slate-700 mb-1.5">
              Motivo Assenza <span className="text-red-500">*</span>
            </label>
            <select
              value={formData.absence_type || ""}
              onChange={(e) => setFormData({ ...formData, absence_type: e.target.value })}
              required
              className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm bg-white"
              data-testid="absence-type"
            >
              <option value="">Seleziona motivo...</option>
              {absenceTypes.map((a) => (
                <option key={a.value} value={a.value}>{a.label}</option>
              ))}
            </select>
          </div>
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => setFormData({ ...formData, absence_full_day: true, scheduled_time: '08:00', scheduled_end_time: '18:00' })}
              className={`flex-1 py-2 px-3 rounded-lg text-sm font-medium border transition ${
                formData.absence_full_day !== false
                  ? 'bg-slate-700 text-white border-slate-800'
                  : 'bg-white text-slate-700 border-slate-300 hover:bg-slate-100'
              }`}
              data-testid="absence-full-day"
            >
              Giornata intera (8:00 - 18:00)
            </button>
            <button
              type="button"
              onClick={() => setFormData({ ...formData, absence_full_day: false })}
              className={`flex-1 py-2 px-3 rounded-lg text-sm font-medium border transition ${
                formData.absence_full_day === false
                  ? 'bg-slate-700 text-white border-slate-800'
                  : 'bg-white text-slate-700 border-slate-300 hover:bg-slate-100'
              }`}
              data-testid="absence-range"
            >
              Range orario
            </button>
          </div>
          <p className="text-xs text-slate-500">
            Per le assenze i campi cliente, indirizzo e installazioni non sono richiesti.
          </p>
          <div>
            <label className="block text-xs font-semibold text-slate-700 mb-1.5">
              Fino al <span className="font-normal text-slate-500">(opzionale — per assenze di più giorni, es. ferie)</span>
            </label>
            <input
              type="date"
              value={formData.absence_end_date || ""}
              min={formData.scheduled_date}
              onChange={(e) => setFormData({ ...formData, absence_end_date: e.target.value })}
              className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm bg-white"
              data-testid="absence-end-date"
            />
            {formData.absence_end_date && formData.absence_end_date > formData.scheduled_date && (
              <p className="text-xs text-slate-600 mt-1" data-testid="absence-range-info">
                Verrà creata un'assenza per ogni giorno dal {new Date(formData.scheduled_date + 'T12:00:00').toLocaleDateString('it-IT')} al {new Date(formData.absence_end_date + 'T12:00:00').toLocaleDateString('it-IT')}
              </p>
            )}
          </div>
        </div>
      )}

      {/* "Altro" subfield: free-text motivo (richiesta Veronica 2026-10-16) */}
      {isOther && (
        <div className="mt-3 p-4 bg-pink-50 border border-pink-200 rounded-lg space-y-2" data-testid="other-details">
          <label className="block text-xs font-semibold text-pink-800 mb-1.5">
            Motivo <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={formData.other_reason || ""}
            onChange={(e) => setFormData({ ...formData, other_reason: e.target.value })}
            required
            placeholder="Es. riunione interna, formazione extra, attività spot..."
            maxLength={200}
            className="w-full px-3 py-2 border border-pink-300 rounded-lg text-sm bg-white"
            data-testid="other-reason"
          />
          <p className="text-xs text-pink-700">
            Per gli interventi di tipo "Altro" compila solo data, orario e installatore.
            Cliente, indirizzo e installazioni non sono richiesti.
          </p>
        </div>
      )}
    </div>
  );
};

export default InterventionTypeSection;
